import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { InfoBlock, InfoBlockTypes } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import styles from './ThreadEmpty.styles.m.css';

export const ThreadEmpty: FC = () => {
  const { t } = useTranslation();

  return (
    <InfoBlock
      className={styles.infoBlock}
      type={InfoBlockTypes.Chat}
      descriptions={[t('comments_status_no_comments_yet')]}
      image={getMascotImageSrc(PROJECT_CONFIG.imageAssets.notFound)}
    />
  );
};
